export default "__VITE_ASSET__CyLWXsUL__"